query bundlesCube($scenarioId: ID!, $originId: ID!, $bundleId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    bundle(id: $bundleId) {
      id
      code
      label
      name
      capacity
      term {
        id
        code
        start_date
        end_date
      }
      sections {
        id
        courseComponent {
          id
        }
      }
      links {
        id
        code
        label
        bundle {
          term {
            id
            code
            name
            start_date
            end_date
          }
        }
        course {
          id
          code
          edhCanEdit
          generatesPackages
          name
          level
          courseType
          curriculum {
            id
            code
            program {
              id
              label
              name
              code
              department {
                id
                code
                name
              }
              modality {
                id
                code
                name
              }
              shift {
                id
                code
                name
              }
              campus {
                id
                code
                name
                __typename
              }
            }
          }
        }
        totalBlocks
        blocksWithoutInstructorAssigment
        instructorResponsability {
          id
          totalBlocks
          components
          teachingHoursPercentage
          isPrimary
          paymentPercentage
          tags
          assignationType {
            id
            code
            name
            enabled
            maxAssignmentsByLink
          }
          instructor {
            id
            code
            name
            hasAccess
          }
        }
        groups {
          id
          code
          label
          name
          capacity
          clientCode
          visibleForEnrollment
          isActive
          isReferent
          groupCapacity {
            retakerCapacity
          }
          term {
            id
            code
            name
          }
          groupSections {
            id
            meta
            code
            __typename
          }
          curriculum {
            id
            code
          }
          course {
            id
            code
            edhCanEdit
            name
            curriculum {
              id
              code
              name
              program {
                id
                label
                name
                code
                department {
                  id
                  code
                  name
                }
                modality {
                  id
                  code
                  name
                }
                shift {
                  id
                  code
                  name
                }
                campus {
                  id
                  code
                  name
                }
              }
            }
          }
          enrollmentStats {
            id
            capacity
            reservedCapacity
            optCapacity
            maxCapacity
            minCapacity
            usedCapacity
            enrollmentsCount
            waitingListsCount
            bookingsCount
            instentsCount
            viewsCount
            retakerEnrollmentsCount
          }
        }
        sections {
          id
          component {
            id
            code
          }
          vacancies
          linksByBundles(bundleId: $bundleId) {
            id
            code
            vacancies
          }
        }
      }
    }
  }
}
